import _ from "lodash";
import { useCommonStore } from "@/store/useCommonStore";

const formatMoney = (sourceStr) => {
  return Number(sourceStr).toFixed(2);
}

const listToTree = (list, options) => {
  options = options || {};
  var ID_KEY = options.idKey || 'id';
  var PARENT_KEY = options.parentKey || 'parent';
  var CHILDREN_KEY = options.childrenKey || 'children';
  var SORT_KEY = options.sortKey || 'sortnum';
  var removeEmptyChildren = options.removeEmptyChildren || true;

  var data = list.sort((a,b)=>a[SORT_KEY]-b[SORT_KEY]);
  
  var tree = [], childrenOf = {};
  var item, id, parentId;

  for(var i = 0, length = data.length; i < length; i++) {
    item = data[i];
    id = item[ID_KEY];
    parentId = item[PARENT_KEY] || 0;
    // every item may have children
    childrenOf[id] = childrenOf[id] || [];
    // init its children
    item[CHILDREN_KEY] = childrenOf[id];
    if (parentId != 0) {
      // init its parent's children object
      childrenOf[parentId] = childrenOf[parentId] || [];
      // push it into its parent's children object
      childrenOf[parentId].push(item);
    } else {
      tree.push(item);
    }    
  };
  if (removeEmptyChildren) {
    data.forEach(item => {
      if (item.children.length == 0) {
        delete item.children;
      }
    });
  }
  return tree;
}

//转换值
const Getvalue = (dictItem,dictValue) => {
  
  let valueItem = _.find(dictItem,item=>item.code == dictValue);
  if(!valueItem) return dictValue;
  return valueItem.name;
}

/**
 * 广度优先搜索（BFS）函数
 * @param {Array|Object} nodes 需要搜索的节点数组或单个节点对象
 * @returns {Array} 搜索结果数组，包含每个节点的id、name和type
 */
const BFS=(nodes)=>{
  // 初始化栈，如果nodes是数组，则直接复制，否则将其包装成数组
  let stack = nodes instanceof Array ? _.clone(nodes) : _.clone([nodes]);
  // 初始化结果数组
  let result = [];
  // 当栈不为空时，继续搜索
  while (stack.length) {
    // 从栈中弹出一个节点
    const { id,type,name,children } = stack.pop();
    // 将节点的id、name和type添加到结果数组中
    result.push({id,name,type});
    // 如果节点有子节点，则将子节点添加到栈中
    if (children) stack.push(...children);
  }
  // 返回搜索结果
  return result;
};

//获取当前页面的缩放值
function detectZoom() {
  var ratio = 0,
      screen = window.screen,
      ua = navigator.userAgent.toLowerCase();

  if (window.devicePixelRatio !== undefined) {
      ratio = window.devicePixelRatio;
  }
  else if (~ua.indexOf('msie')) {
      if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
      }
  }
  else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
      ratio = window.outerWidth / window.innerWidth;
  }

  if (ratio) {
      ratio = Math.round(ratio * 100);
  }
  return ratio;
}

/**
 * 以递归的方式展平react router数组
 * @param {object[]} arr 路由数组
 * @param {string} child 需要递归的字段名
 */
 const flattenRoutes = (arr) =>
 arr.reduce(
   (prev, item) => {
     if (Array.isArray(item.routes)) {
       prev.push(item)
     }
     return prev.concat(
       Array.isArray(item.routes) ? flattenRoutes(item.routes) : item
     )
   },
   []
 )

/**
 * 根据路径获取路由的name和key
 * @param {string} path 路由
 */
 const getKeyName = (path = '/403') => {
  const truePath = path.split('?')[0];
  const curRoute = flattenRoutes(routers).filter(
    (item) => {
      let params = item.path.replace(RegExp("/:([a-zA-Z0-9]+)","g"),"/\[a-zA-Z0-9]+");
      return RegExp(params,"g").test(truePath);
    }
  )
  if (!curRoute[0])
    return { title: '暂无权限', tabKey: '403', component: ErrorPage }
  const { name, key, component } = curRoute[0]
  //component.preload();
  return { title: name, tabKey: key, component }
}

const extractValueWithKeyFromObject = (data, key, seperator = '/') => {
  if (!key) return undefined;
  let result = data;
  const keys = key.split(seperator);
  for (let i = 0; i < keys.length && result && typeof result === 'object'; i++){
    result = result[keys[i]];
  }
  return result;
}

const array2Object = (array, keyName) => array.reduce((acc, item) => ({ ...acc, [item[keyName]]: item }), {});

export function isAdminRole () {
  const {user, rolelist} = useCommonStore.getState();
  console.log('【isAdminRole】', user, rolelist);
  return Array.isArray(rolelist) && rolelist.some(r => r?.SystemName?.toUpperCase() === 'Administrators'.toUpperCase());
}

export {
  formatMoney,
  BFS,
  detectZoom,
  getKeyName,
  extractValueWithKeyFromObject,
  flattenRoutes,
  listToTree,
  array2Object,
  Getvalue,
}